import _ from 'lodash';
import {CALL_API} from 'redux-api-middleware';
import {
  SNAPSHOT_POST_REQUEST,
  SNAPSHOT_POST_SUCCESS,
  SNAPSHOT_POST_FAILURE,
} from 'common/types';
import {ENDPOINT_SNAPSHOT} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  postSnapshot: (token, payload) => {
    let bodyPayload = payload;
    const id = _.get(payload, 'id');
    const endpointToUse = `${ENDPOINT_SNAPSHOT}${id}`;
    const snapshotReason = _.get(payload, 'snapshotReason');

    bodyPayload = {
      snapshotReason,
      data: payload,
    };

    return {
      [CALL_API]: {
        endpoint: endpointToUse,
        headers: commonJwtHeader(),
        body: JSON.stringify(bodyPayload),
        method: 'POST',
        types: [SNAPSHOT_POST_REQUEST, SNAPSHOT_POST_SUCCESS, SNAPSHOT_POST_FAILURE],
      },
    };
  },
};
